TS.ns('WL');

WL.documentAutomaticTransitionModel = new Class({
    Extends: TS.domain.EditDomain,


    createProperties: function (config) {
        var me = this;
        
        me.parent(config);

        var detailList = me.getDomainProperty('gridDetail_Property');
        
        if (detailList) {
            var cat = detailList.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'AddDetail';
            newCmd['Text'] = me.AddActionCommandText;
            newCmd['handler'] = '_addDetail';
            newCmd['IconCode'] = 'plus';

            if (!me.ReadOnly())
                cat.push(newCmd);
        }
    },

    _addDetail: function () {
        var me = this;

        me.performServerCommand({ cmd: 'AddDetail', submitModel: true, extraData: {}, blockUI: true });
    }
});
